import { useTranslations } from '@vocab/react';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTypedSelector } from 'src/reducers';

import { useSetCandidateId } from '../hooks/useSetCandidateId';
import { useUserProfile } from '../hooks/useUserProfile';
import PageLoader from '../page-loader';
import { PageTitles } from '../pageTitle';
import { useRoutes } from '../routes';
import { useSetTrackingContext } from '../tracking/tealium';

import translations from './.vocab';
import SubscribeJobAlert from './jobalert';
import Subscribe from './subscribe';
import SubscribeCTP from './subscribe-ctp';

const SubscribeContainer = () => {
  const { authenticationStatus } = useUserProfile();

  useSetCandidateId();

  useSetTrackingContext();

  const [token, setToken] = useState<string>('');
  const [product, setProduct] = useState<string>('');
  const [isCTPSubscribe, setIsCTPSubscribe] = useState<boolean>(false);

  const navigate = useNavigate();
  const { preferenceCentrePath } = useRoutes();
  const location = useLocation();
  const brand = useTypedSelector((store) => store.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramToken = params.get('token');
    const paramProduct = params.get('product');
    const paramCTP = params.get('ctp');
    if (paramProduct) {
      setProduct(paramProduct);
    }
    if (paramToken) {
      setToken(paramToken);
    } else {
      navigate(preferenceCentrePath);
    }
    setIsCTPSubscribe(paramCTP === 'true');
  }, [navigate, location.search, preferenceCentrePath]);

  const getSubscriptionContent = () => {
    if (product?.toLocaleLowerCase() === 'jobalert') {
      return (
        <SubscribeJobAlert
          token={token}
          authenticationStatus={authenticationStatus}
        />
      );
    }

    return isCTPSubscribe ? (
      <SubscribeCTP token={token} />
    ) : (
      <Subscribe token={token} />
    );
  };

  return (
    <>
      <Helmet>
        <title>{`${PageTitles[brand]} - ${t('subscribe-page-title')}`}</title>
      </Helmet>
      {token ? getSubscriptionContent() : <PageLoader />}
    </>
  );
};

export default SubscribeContainer;
